module.exports = require('./helpers/bundle-url').getBundleURL('cFItr') + "logo-dark.eefe0b7f.svg";